<div class="modal-overlay" (click)="onOverlayClick($event)">
  <div class="modal-content">
    <div class="modal-header">
      <h3 class="modal-title">Login to Scholarship Portal</h3>
      <button class="modal-close" (click)="closeModal.emit()">&times;</button>
    </div>

    <div class="modal-body">
      <!-- Error Message -->
      @if (errorMessage) {
        <div class="alert alert-error">
          <i class="fas fa-exclamation-circle"></i> {{ errorMessage }}
        </div>
      }

      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
        <div class="form-group">
          <label for="login-email">Username or Email</label>
          <input type="text" id="login-email" class="form-control" formControlName="email" autocomplete="username"
            placeholder="Enter your username or email">
          @if (loginForm.get('email')?.invalid && loginForm.get('email')?.touched) {
            <div class="error-text">
              Username or email is required
            </div>
          }
        </div>

        <div class="form-group">
          <label for="login-password">Password</label>
          <div class="password-wrapper">
            <input type="{{ showPassword ? 'text' : 'password' }}" id="login-password" class="form-control"
              formControlName="password" autocomplete="current-password" placeholder="Enter your password">
            <button type="button" class="toggle-password" (click)="togglePasswordVisibility()">
              <i class="fas" [ngClass]="showPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
            </button>
          </div>
        </div>

        <div class="form-group checkbox-group">
          <input type="checkbox" id="remember-me" formControlName="rememberMe">
          <label for="remember-me">Remember me</label>
        </div>

        <div class="forgot-password">
          <a href="#">Forgot password?</a>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="closeModal.emit()">Cancel</button>
          <button type="submit" class="btn btn-primary" [disabled]="loginForm.invalid || isLoading">
            @if (!isLoading) {
              <span>Login</span>
            }
            @if (isLoading) {
              <span><i class="fas fa-spinner fa-spin"></i> Logging in...</span>
            }
          </button>
        </div>
      </form>

      <div class="register-link">
        Don't have an account?
        <a routerLink="/auth/register" (click)="closeModal.emit()">Register here</a>
      </div>
    </div>
  </div>
</div>